import { Pagination } from "../index";
export const INPUT_TYPES = [
  { value: "text", label: "Texto" },
  { value: "number", label: "Número" },
  { value: "radio", label: "Radio" },
  { value: "checkbox", label: "Checkbox" },
  { value: "table", label: "Tabla" },
  { value: "select", label: "Combobox" }
];

export const HEADER_TYPES = [
  { value: "text", label: "Texto" },
  { value: "number", label: "Número" },
  { value: "checkbox", label: "Checkbox" },
  { value: "select", label: "Combobox" }
];

export type InputDependency = {
  variable: string;
  value: any;
};

export type InputOption = {
  label: string;
  value: any;
};

export type InputHeader = {
  name: string;
  type: "text" | "number" | "checkbox" | "select";
  required: boolean;
  label: string;
  options: InputOption[];
};

export type TemplateInput = {
  id?: string;
  name: string;
  type: "text" | "number" | "radio" | "checkbox" | "table" | "select";
  required: boolean;
  readonly: boolean;
  label: string;
  hint?: string;
  size?: number;
  placeholder?: string;
  options: InputOption[];
  depends_on: InputDependency[];
  headers: InputHeader[];
};

export type TemplateSection = {
  id?: string;
  title: string;
  text?: string;
  inputs: TemplateInput[];
};

export type FilePayload = {
  name: string;
  size: number;
  content?: string;
};

export type RawTemplate = {
  id?: string;
  name: string;
  description: string;
  sections: TemplateSection[];
  source?: FilePayload;
};

export type TemplateResource = {
  id: string;
  type: "template";
  attributes: {
    id: string;
    name: string;
    description: string;
    drive_id: string;
    sections: TemplateSection[];
    source?: FilePayload;
  };
  meta: {
    created_at: string;
    updated_at: string;
    requests_count: number;
  };
};

export type TemplateIndexResponse = {
  templates: {
    data: TemplateResource[];
  };
  pagination: Pagination & { totalItems: number };
};

export type TemplateShowResponse = {
  data: TemplateResource;
};

export interface TemplateState {
  templates: { [key: string]: TemplateResource };
  templatesList: string[];
  selected: RawTemplate;
  activeSection: number;
}
